import { render, staticRenderFns } from "./Voted.vue?vue&type=template&id=3063bbb7&lang=pug&"
import script from "./Voted.vue?vue&type=script&lang=ts&"
export * from "./Voted.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports